import { render, staticRenderFns } from "./Heading2.vue?vue&type=template&id=413f1688&scoped=true&"
import script from "./Heading2.vue?vue&type=script&lang=ts&"
export * from "./Heading2.vue?vue&type=script&lang=ts&"
import style0 from "./Heading2.vue?vue&type=style&index=0&id=413f1688&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f1688",
  null
  
)

export default component.exports